/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.groupModule')
.directive('bulbGoogleClassroomImport', [function() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/group/google-classroom-import.html',
    controller: 'GoogleClassroomImportController as googleClassroomImportCtrl',
  };
}]);
